jQuery(document).ready(function (jQuery) {
  jQuery(".open-shoppint-cart").on("click", function () {
    console.log('sitting');
    jQuery(".ajaxaddtocart-popup").addClass("_show");
    if (jQuery('.modal-backdrop.for-menu').length === 0) {
      jQuery('body').append(
        '<div class="modal-backdrop fade show for-menu"></div>'
      );
    }
    jQuery("body").addClass("menu-open");
  });
  jQuery(".btn-close.shopping-cart").on("click", function () {
    jQuery(".ajaxaddtocart-popup").removeClass("_show");
    jQuery(".modal-backdrop").remove();
    jQuery("body").removeClass("menu-open");
  });

  jQuery(document).delegate(".modal-backdrop", "click", function (e) {
    jQuery(".ajaxaddtocart-popup").removeClass("_show");
    jQuery(".modal-backdrop").remove();
    jQuery("body").removeClass("menu-open");
  });

  jQuery(document).delegate(".qty-btn.plus", "click", function (e) {
    $input = jQuery(this).prev("input.qty");
    var val = parseInt($input.val());
    $input.val(val + 1).change();

    jQuery(this).parent().find(".btn-update").click();
  });

  jQuery(document).delegate(".input-text.qty", "change", function (e) {
    jQuery(this).parent().find(".btn-update").click();
  });

  jQuery(document).delegate(".qty-btn.minus", "click", function (e) {
    $input = jQuery(this).next("input.qty");
    var val = parseInt($input.val());
    if (val > 0) {
      $input.val(val - 1).change();
    }

    jQuery(this).parent().find(".btn-update").click();
  });

  // jQuery(document.body).on("click", ".add-to-cart", function (e) {
  //   cart_sidebar_open();
  //   var $form = jQuery(this).closest("form");
  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: $form.serialize(),
  //     dataType: "json",
  //     success: function () {
  //       cart_sidebar_update();

  //       // Warranty logic only on product pages
  //       var $modal = jQuery("#warranty-modal");
  //       if ($modal.length === 0 || typeof window.warrantyMap === "undefined")
  //         return;

  //       // Get selected variant label (assumes variant label contains "Single" or "Dual")
  //       var selectedOption = $form
  //         .find('select[name="id"] option:selected')
  //         .text()
  //         .toLowerCase();
  //       console.log(selectedOption);
  //       console.log(window.warrantyMap);
  //       var warrantyKey = selectedOption.includes("dual")
  //         ? "Dual Sided"
  //         : "Single Sided";
  //       var warrantyData = window.warrantyMap[warrantyKey];
  //        console.log(warrantyData);
  //       if (!warrantyData || !warrantyData.variantId) return;

  //       // Update price
  //       $modal.find("#warranty-price").text(`$${warrantyData.price}`);

  //       // Bind add-to-cart handler once (unbind first to avoid duplicate binding)
  //       $modal
  //         .find('.btn[href="javascript:void(0);"]')
  //         .off("click")
  //         .on("click", function () {
  //           jQuery.ajax({
  //             type: "POST",
  //             url: "/cart/add.js",
  //             dataType: "json",
  //             data: {
  //               quantity: 1,
  //               id: warrantyData.variantId,
  //             },
  //             success: function () {
  //               var modalInstance = bootstrap.Modal.getOrCreateInstance(
  //                 $modal[0]
  //               );
  //               modalInstance.hide();
  //               cart_sidebar_update(); // refresh cart
  //             },
  //             error: function (err) {
  //               console.error("Warranty add error:", err);
  //             },
  //           });
  //         });

  //       // ✅ Show modal
  //       var modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
  //       modalInstance.show();
  //     },
  //     error: function (xhr, text) {
  //       jQuery(".cart-sidebar-error-message").show();
  //       jQuery(".cart-sidebar-error-message").text(
  //         jQuery.parseJSON(xhr.responseText).description
  //       );
  //       cart_sidebar_update();
  //       jQuery("#cart-sidebar .cart-sidebar-loading").hide();
  //     },
  //   });
  //   e.preventDefault();
  // });

  // jQuery(document.body).on("click", ".add-to-cart", function (e) {
  //   cart_sidebar_open();
  //   var $form = jQuery(this).closest("form");

  //   jQuery.ajax({
  //     type: "POST",
  //     url: "/cart/add.js",
  //     data: $form.serialize(),
  //     dataType: "json",
  //     success: function () {
  //       cart_sidebar_update();

  //       var $modal = jQuery("#warranty-modal");
  //       if ($modal.length === 0 || typeof window.warrantyMap === "undefined")
  //         return;

  //       let warrantyKey = "";

  //       // ✅ Product page: use selected variant text
  //       const $select = $form.find('select[name="id"]');
  //       if ($select.length) {
  //         const selectedText = $select
  //           .find("option:selected")
  //           .text()
  //           .toLowerCase();
  //         warrantyKey = selectedText.includes("dual")
  //           ? "Dual Sided"
  //           : "Single Sided";
  //       } else {
  //         // ✅ Collection page: use product title as-is
  //         console.log($form);
  //         const productTitle = $form
  //           .find('input[name="id"]')
  //           .data("producttitle");
  //         console.log('Title:' + productTitle);
  //         if (productTitle) {
  //           //warrantyKey = title.includes("dual")
  //           warrantyKey = productTitle.toLowerCase().includes("dual")
  //            ? `${productTitle} - Dual Sided`
  //            : `${productTitle} - Single Sided`;

  //            if(warrantyKey == 'Seaory R660 Retransfer Printer - Single Sided'){
  //             warrantyKey = 'Seaory R660 Retransfer Printer - Dual Sided';
  //           }
  //         }

         
  //       }

      
  //       const warrantyData = window.warrantyMap[warrantyKey];
  //       if (!warrantyData || !warrantyData.variantId) return;
        
  //       $modal.find("#warranty-price").text(`$${warrantyData.price}`);

  //       $modal
  //         .find('.btn[href="javascript:void(0);"]')
  //         .off("click")
  //         .on("click", function () {
  //           jQuery.ajax({
  //             type: "POST",
  //             url: "/cart/add.js",
  //             dataType: "json",
  //             data: {
  //               quantity: 1,
  //               id: warrantyData.variantId,
  //             },
  //             success: function () {
  //               const modalInstance = bootstrap.Modal.getOrCreateInstance(
  //                 $modal[0]
  //               );
  //               modalInstance.hide();
  //               cart_sidebar_update();
  //             },
  //             error: function (err) {
  //               console.error("Warranty add error:", err);
  //             },
  //           });
  //         });

  //       const modalInstance = bootstrap.Modal.getOrCreateInstance($modal[0]);
  //       modalInstance.show();
  //     },
  //     error: function (xhr, text) {
  //       jQuery(".cart-sidebar-error-message").show();
  //       jQuery(".cart-sidebar-error-message").text(
  //         jQuery.parseJSON(xhr.responseText).description
  //       );
  //       cart_sidebar_update();
  //       jQuery("#cart-sidebar .cart-sidebar-loading").hide();
  //     },
  //   });

  //   e.preventDefault();
  // });

jQuery(document.body).on("click", ".add-to-cart", function (e) {
  e.preventDefault();

  cart_sidebar_open(); // ✅ Open immediately

  const $form = jQuery(this).closest("form");

  // 1️⃣ Check cart BEFORE adding
  jQuery.getJSON("/cart.js", function (cart) {
  
    // ✅ Get PRODUCT ID, not variant ID
    const productId = parseInt(
      $form.find('select[name="id"], input[name="id"]').data('productid'),
      10
    );

    const productAlreadyInCart = cart.items.some(item => item.product_id === productId);

    // 2️⃣ Add product
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: $form.serialize(),
      dataType: "json",
      success: function (addedProduct) {
        cart_sidebar_update();

        if (productAlreadyInCart) {
          return; // Skip warranty modal
        }

        // 3️⃣ Warranty logic
        showWarrantyModal($form, addedProduct);
      },
      error: function (xhr) {
        jQuery(".cart-sidebar-error-message").show().text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  });
});

function showWarrantyModal($form, addedProduct) {
  const $modal = jQuery("#warranty-modal");
  if (!$modal.length || typeof window.warrantyMap === "undefined") return;

  let productTitle = "";
  const $select = $form.find('select[name="id"]');
  if ($select.length) {
    productTitle = $select.find("option:selected").text().trim();
  }
  if (!productTitle) {
    productTitle = $form.find('input[name="id"]').data("producttitle") || "";
  }
  if (!productTitle) return;

  const warrantyData = window.warrantyMap[productTitle];
  if (!warrantyData) return;

  // --- Populate Modal Prices ---
  if (warrantyData.single) {
    $modal.find("#warranty-price").text(`$${warrantyData.single.price}`);
  }
  if (warrantyData.one_year) {
    $modal.find("#warranty-price-1").text(`$${warrantyData.one_year.price}`);
  }

  // --- 5-Year Plan ---
  $modal.find(".war_btn")
    .off("click")
    .on("click", function () {
      if (!warrantyData.single) return;
      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: {
          quantity: 1,
          id: warrantyData.single.variantId,
        },
        success: function () {
          bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
          cart_sidebar_update();
        },
        error: function (err) {
          console.error("5-Year Warranty add error:", err);
        },
      });
    });

  // --- 1-Year Plan (with Selling Plan) ---
  $modal.find('.war_btn1') // 1-year subscription button
  .off("click")
  .on("click", function () {
    if (!warrantyData.one_year || !warrantyData.one_year.variantId) return;

    const postData = {
      quantity: 1,
      id: warrantyData.one_year.variantId,
    };

    // Add selling_plan if it exists
    if (warrantyData.one_year.sellingPlan) {
      postData.selling_plan = warrantyData.one_year.sellingPlan;
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: postData,
      success: function () {
        bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
        cart_sidebar_update();
      },
      error: function (err) {
        console.error("1-Year Warranty add error:", err);
      },
    });
  });

  bootstrap.Modal.getOrCreateInstance($modal[0]).show();
}

  jQuery(".__leasing").on("click", function (e) {
    cart_sidebar_open();
    var class_name = jQuery(this).data("class");
    console.log(class_name);
    jQuery("." + class_name + " .__leasing_addons_1").click();
    e.preventDefault();
  });

  jQuery(".__leasing_addons_1").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    console.log(class_name);
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        jQuery("." + class_name + " .__leasing_addons_2").click();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });
  jQuery(".__leasing_addons_2").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        jQuery("." + class_name + " .__leasing_addons_3").click();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });
  jQuery(".__leasing_addons_3").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        jQuery("." + class_name + " .__leasing_addons__1").click();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });
  jQuery(".__leasing_addons__1").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        jQuery("." + class_name + " .__leasing_addons__2").click();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });
  jQuery(".__leasing_addons__2").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        jQuery("." + class_name + " .__leasing_main").click();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });
  jQuery(".__leasing_main").on("click", function (e) {
    var form = jQuery(this).closest("form");
    var class_name = jQuery(this).data("class");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {},
    });
    e.preventDefault();
  });

  var EDITION_ORDER = ['bronze', 'silver', 'gold', 'platinum', 'diamond'];

  function getEditionRank(name) {
    if (!name) return -1;
    var s = String(name).toLowerCase();
    for (var i = 0; i < EDITION_ORDER.length; i++) {
      if (s.indexOf(EDITION_ORDER[i]) !== -1) return i;
    }
    return -1;
  }

  function getSelectedEditionText() {
    var val = '';
    var $r = jQuery('input[name="Color"]:checked, input[name="color"]:checked').first();
    if ($r.length) val = $r.val();
    if (!val) {
      var $sel = jQuery('.swatch-attribute.color .swatch-option.selected').first();
      if ($sel.length) val = $sel.data('value') || '';
    }
    if (!val) {
      val = jQuery('#Variants-' + (jQuery('[id^="Variants-"]').first().attr('id') || '').replace('Variants-', '')).find('option:selected').text() || '';
    }
    return val;
  }

  function doAddToCartWithKey(form_data) {
    jQuery(".key-error-msg").hide();
    jQuery(".modal .btn-close").click();
    cart_sidebar_open();
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form_data,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  }

  function showUpgradeModal(currentEdition, newEdition, form_data) {
    var $modal = jQuery("#software-upgrade-modal");
    if (!$modal.length) {
      var modalHtml =
        '<div class="modal fade" id="software-upgrade-modal" tabindex="-1" aria-hidden="true">' +
          '<div class="modal-dialog modal-dialog-centered">' +
            '<div class="modal-content">' +
              '<div class="modal-header">' +
                '<h5 class="modal-title">Upgrade Your Software Edition</h5>' +
                '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
              '</div>' +
              '<div class="modal-body">' +
                '<p>You are going to upgrade from <strong class="current-edition"></strong> <strong>Edition</strong> to <strong class="new-edition"></strong> of Bodno Software.</p>' +
                '<p>Do you want to continue?</p>' +
              '</div>' +
              '<div class="modal-footer">' +
                '<button type="button" class="btn btn--red-out" data-bs-dismiss="modal">Cancel</button>' +
                '<button type="button" class="btn btn--red confirm-upgrade">Upgrade</button>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>';
      jQuery('body').append(modalHtml);
      $modal = jQuery("#software-upgrade-modal");
    }
    $modal.find('.current-edition').text(currentEdition);
    $modal.find('.new-edition').text(newEdition);
    $modal.find('.confirm-upgrade').off('click').on('click', function () {
      bootstrap.Modal.getOrCreateInstance($modal[0]).hide();
      doAddToCartWithKey(form_data);
    });
    bootstrap.Modal.getOrCreateInstance($modal[0]).show();
  }

  jQuery(".add-to-cart-with-key").on("click", function (e) {
    e.preventDefault();

    if (!jQuery("#activation-key").val()) {
      jQuery("#activation-key").focus();
      jQuery(".key-error-msg").show().html("Enter Activation code");
      return;
    }

    var activation_code = jQuery("#activation-key").val();
    jQuery("#_activation-key").val(activation_code);
    var form = jQuery(this).closest("form");
    var form_data = form.serialize();

    var selectedEditionText = getSelectedEditionText();
    var selectedRank = getEditionRank(selectedEditionText);

    jQuery.ajax({
      url: "https://api.bodno.com/status/check",
      type: "post",
      data: JSON.stringify({
        activation_key: activation_code,
      }),
      success: function (response) {
        if (!response || response.status == "404" || !response.edition) {
          jQuery(".key-error-msg").show().html(
            (response && response.message) ||
              "License is not valid. Please email Orders@Bodno.com or call 732-987-5300 for assistance."
          );
          return;
        }

        var apiEdition = response.edition;
        var apiRank = getEditionRank(apiEdition);

        if (apiRank === -1 || selectedRank === -1) {
          jQuery(".key-error-msg").hide();
          doAddToCartWithKey(form_data);
          return;
        }

        if (selectedRank === apiRank) {
          jQuery(".key-error-msg").hide();
          doAddToCartWithKey(form_data);
        } else if (selectedRank > apiRank) {
          jQuery(".key-error-msg").hide();
          showUpgradeModal(apiEdition, selectedEditionText, form_data);
        } else {
          jQuery(".key-error-msg").show().html(
            "Downgrade is not allowed. Your activation code is for the " +
              apiEdition +
              " Edition. Please select " +
              apiEdition +
              " Edition or higher."
          );
        }
      },
      error: function () {
        jQuery(".key-error-msg").show().html(
          "Unable to verify activation code. Please try again."
        );
      },
    });
  });

  jQuery(".add-to-cart-with-key-code").on("click", function (e) {
    if (!jQuery("#facility-code").val()) {
      jQuery(".facility-error-msg").show();
      jQuery("#facility-code").focus();
      return false;
    } else {
      jQuery(".facility-error-msg").hide();
    }
    if (!jQuery("#sequence-code").val()) {
      jQuery(".sequence-error-msg").show();
      jQuery("#sequence-code").focus();
      return false;
    } else {
      jQuery(".sequence-error-msg").hide();
    }

    cart_sidebar_open();
    var form = jQuery(this).closest("form");
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: form.serialize(),
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });

    e.preventDefault();
  });

  function cart_sidebar_open() {
    //console.log('cart_sidebar_open');
    jQuery("#cart-sidebar").addClass("active");
    jQuery(".ajaxaddtocart-popup").addClass("_show");
    if (jQuery('.modal-backdrop.for-menu').length === 0) {
      jQuery('body').append(
        '<div class="modal-backdrop fade show for-menu"></div>'
      );
    }
    jQuery("body").addClass("menu-open");
    jQuery("#cart-sidebar").addClass("_loading");
    jQuery(".overlay").addClass("active");

    jQuery("#cart-sidebar").addClass("_loading");
  }

  function cart_sidebar_update() {
    jQuery.getJSON("/cart.js", function (cart) {
      //console.log(cart);
      cart_sidebar_update_mini_cart(cart);
      cart_sidebar_update_free_shipping(cart);
      cart_sidebar_update_product(cart);
      cart_sidebar_update_totals(cart);

      jQuery("#cart-sidebar").removeClass("_loading");
      jQuery("#cart-sidebar").removeClass("is_empty");
      jQuery("#cart-items").removeClass("_loading");
      jQuery("#cart-items").removeClass("is_empty");

      if (cart.item_count == 0) {
        jQuery("#cart-sidebar").addClass("is_empty");
        jQuery("#cart-items").addClass("is_empty");
      }
    });
  }

  function cart_sidebar_update_mini_cart(cart) {
    jQuery(".mini-cart span.cart-count").text(cart.item_count);
    jQuery(".summary span.cart-count").text(cart.item_count);
  }
  function cart_sidebar_update_free_shipping(cart) {}
  function cart_sidebar_update_product(cart) {
    console.log(cart);
    var template =
      '<li class="cart-item __cart_sidebar_{ID} {FREE_ITEM} __item_type_{TYPE}" data-id="{ID}"><a href="{URL}" class="product-image"><div class="g-box"><div class="g-box-inner"><img src="{IMAGE}" alt="{NAME}" width="100"></div></div></a><div class="shoppingcart-product-detail"><div class="shoppingcart-product-name"><a href="{URL}">{NAME}</a>{PLAN}{EXTRA_HTML}{OPTION}{OPTION2}{PROPERTIES}</div><div class="shoppingcart qty-control"><span class="qty-btn minus">-</span><input type="number" name="qty" id="qty_{ID}" maxlength="12" data-id="{ID}" value="{QUANTITY}" title="Qty" class="input-text qty"><span class="qty-btn plus">+</span><button type="submit" name="update_cart_action" data-id="{ID}" value="update_qty" title="Update" class="btn-update d-none">Update</button></div></div><div class="d-flex flex-column justify-content-between align-items-end ms-auto"><span class="shoppingcart-price"><span class="price">{PRICE}</span></span><a href="#" title="Remove This Item" data-id="{ID}" class="shoppingcart-remove-item"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"/><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"/></svg></a></div></li>{WARRANTY}';
    var ProductList = jQuery("#shoppingcart-products-list");
    var ProductList2 = jQuery("#cart-items");
    if (cart.item_count > 0) {
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].image) {
          var __image_url = cart.items[i].image;
          var __image_url_array = __image_url.split(".");
          var __image_url_replace =
            "." + __image_url_array[__image_url_array.length - 1];
          var __image_url_new =
            "_100x100." + __image_url_array[__image_url_array.length - 1];
          var __image_url_final = __image_url.replace(
            __image_url_replace,
            __image_url_new
          );
        } else {
          var __image_url_final =
            "https://cdn.shopify.com/s/files/1/0644/8037/9134/t/2/assets/placeholder.jpg";
        }

        if (i == 0) {
          ProductList.html("");
          ProductList2.html("");
        }

        if (cart.items[i].discounted_price == 0) {
          var free_item = "__free_item";
        } else {
          var free_item = "";
        }

        if (cart.items[i].product_id == 7930026000638) {
          var extra_html =
            '<p class="product-option" style="font-size:11px;">1 x Magicard 300 ID Card Printer<br/>1 x Bodno ID Card Software Silver Edition<br/>1 x Bodno Full HD 1080p Web Camera<br/>1 x CR80 30 Mil PVC Cards - 300 Pack - Annually<br/>2 x Magicard MC300YMCKO Color Ribbon MC300YMCKO/2 - Annually</p>';
        } else if (cart.items[i].product_id == 7936042369278) {
          var extra_html =
            '<p class="product-option" style="font-size:11px;">1 x Badgy100 ID Card Printer<br/>1 x Bodno ID Card Software Silver Edition<br/>1 x Bodno Full HD 1080p Web Camera<br/>1 x CR80 30 Mil PVC Cards - 100 Pack - Annually<br/>1 x Evolis Badgy CBGR0100C Color Ribbon - Annually</p>';
        } else {
          var extra_html = "";
        }

        var plan_html = "";
        if (cart.items[i].selling_plan_allocation) {
          var text = cart.items[i].selling_plan_allocation.selling_plan.name;
          plan_html =
            '<p class="product-option" style="font-size:11px;">' +
            text.replace("Delivery", "Charge") +
            "</p>";
        }

        var item = template;
        item = item.replace(/\{ID\}/g, cart.items[i].id);
        item = item.replace(/\{FREE_ITEM\}/g, free_item);
        item = item.replace(/\{EXTRA_HTML\}/g, extra_html);
        item = item.replace(/\{TYPE\}/g, cart.items[i].product_type);
        if(cart.items[i].product_type == 'Rental'){
          item = item.replace(/\{URL\}/g, 'javascript:void(0);');
        }else{
          item = item.replace(/\{URL\}/g, cart.items[i].url);
        }
        
        item = item.replace(/\{NAME\}/g, cart.items[i].product_title);
        item = item.replace(/\{VARIANT\}/g, cart.items[i].variant_title || "");
        item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
        item = item.replace(/\{IMAGE\}/g, __image_url_final);
        item = item.replace(/\{PLAN\}/g, plan_html);
        if (cart.items[i].discounted_price == 0) {
          item = item.replace(/\{PRICE\}/g, "FREE");
        } else {
          item = item.replace(
            /\{PRICE\}/g,
            Shopify.formatMoney(cart.items[i].discounted_price)
          );
        }

        var option = "";
        var option2 = "";
        if (cart.items[i].options_with_values) {
          for (var p = 0; p < cart.items[i].options_with_values.length; p++) {
            if (p == 0) {
              if (
                cart.items[i].options_with_values[p].value != "Default Title"
              ) {
                option =
                  '<p class="product-option">' +
                  cart.items[i].options_with_values[p].name +
                  ": " +
                  cart.items[i].options_with_values[p].value +
                  "</p>";
              }
            }
            if (p == 1) {
              if (
                cart.items[i].options_with_values[p].value != "Default Title"
              ) {
                option2 =
                  '<p class="product-option">' +
                  cart.items[i].options_with_values[p].name +
                  ": " +
                  cart.items[i].options_with_values[p].value +
                  "</p>";
              }
            }
          }
        }

        item = item.replace(/\{OPTION\}/g, option);
        item = item.replace(/\{OPTION2\}/g, option2);

        var properties = cart.items[i].properties || {};
        var allPropsHtml = "";

        // Loop through all properties
        for (var key in properties) {
          if (
            properties.hasOwnProperty(key) &&
            properties[key] !== "" &&
            key !== "_warranty" &&
            key !== "_warranty_price" &&
            key !== "_brand_warranty" &&
            key !== "_source" &&
            key !== "_widget_id" &&
            key !== "_attribution"
          ) {
            allPropsHtml +=
              '<p class="product-property">' +
              key +
              ": " +
              properties[key] +
              "</p>";
          }
        }

        // Replace placeholder in item template

        item = item.replace(/\{PROPERTIES\}/g, allPropsHtml);

        var _warranty = "";
        var WARRANTY = "";
        if (cart.items[i].properties) {
          if (cart.items[i].properties._warranty) {
            var _warranty = cart.items[i].properties._warranty;
          }
          if (cart.items[i].properties._brand_warranty) {
            var brand_warranty = cart.items[i].properties._brand_warranty;

            _brand_warranty = 5 - brand_warranty;
            // if(brand_warranty==3){
            //   _brand_warranty=2;
            // } else {
            //   _brand_warranty=3;
            // }
          }
          if (cart.items[i].properties._warranty_price) {
            var _warranty_price = cart.items[i].properties._warranty_price;
          }

          if (_warranty != "") {
            WARRANTY =
              '<li class="warranty_item warranty-' +
              _warranty +
              '" style="display:block!important;"><span class="d-flex align-items-center justify-content-between flex-nowrap gap-2"><input type="radio" name="id" class="warranty_cart_item" value="' +
              _warranty +
              '"><span>Add 5-Year Printer Protection for ' +
              Shopify.formatMoney(_warranty_price) +
              '</span><span class="flex-shrink-0"><img src="//bodno.com/cdn/shop/t/26/assets/bodno-total-care-new.png" height="34" width="142" alt="bodno-totalcare "></span></span></li>';
          }
        }

        item = item.replace(/\{WARRANTY\}/g, WARRANTY);

        ProductList.append(item);
        ProductList2.append(item);
      }

      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].sku == "Warranty") {
          jQuery(".warranty-" + cart.items[i].id).hide();
        }
      }
    } else {
      ProductList.html("");
      jQuery("#cart-sidebar").addClass("is_empty");
      jQuery("#cart-items").addClass("is_empty");
    }
  }
  function cart_sidebar_update_totals(cart) {
    jQuery(".__subtotal span").html(Shopify.formatMoney(cart.total_price));
    jQuery(".__total span").html(Shopify.formatMoney(cart.total_price));
  }

  function cart_sidebar_update_quantity(product_id, quantity) {
    cart_sidebar_open();
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=" + quantity + "&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });
  }

  jQuery(document).delegate(".cart-item .btn-update", "click", function (e) {
    var quantity = jQuery(this).parent().find("input").val();
    var product_id = jQuery(this).parent().find("input").attr("data-id");
    cart_sidebar_update_quantity(product_id, quantity);
  });

  jQuery(document).delegate(".warranty_cart_item", "click", function (e) {
    cart_sidebar_open();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: "quantity=1&id=" + jQuery(this).val(),
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").show();
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        cart_sidebar_update();
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });
    e.preventDefault();
  });

  jQuery(document).delegate(".shoppingcart-remove-item", "click", function (e) {
    cart_sidebar_open();
    var product_id = jQuery(this).attr("data-id");
    jQuery.ajax({
      type: "POST",
      url: "/cart/change.js",
      data: "quantity=0&id=" + product_id,
      dataType: "json",
      success: function () {
        cart_sidebar_update();
      },
      error: function (xhr, text) {
        jQuery(".cart-sidebar-error-message").text(
          jQuery.parseJSON(xhr.responseText).description
        );
        jQuery("#cart-sidebar .cart-sidebar-loading").hide();
      },
    });

    e.preventDefault();
  });


  jQuery(".pdp-qty .qty").on("change keyup paste", function () {
    jQuery(".__leasing_qty").val(jQuery(this).val());
    jQuery(".__leasing_qty_2").val(2 * jQuery(this).val());
  });

  $("#qty").on("input change", function () {
    $(".hqty").val($(this).val());
  });
});
